import { INewComment, IServerComment } from '../Models/Comment';
import { ApiService } from '../_services/ApiService';

export class CommentService extends ApiService {
    protected basePath = 'comments';

    public getCommentsForStoryAndPhoto(collection_id: number, photo_id: number): Promise<Array<IServerComment>> {
        return this.getRequest({ collection_id, photo_id });
    }

    public postCommentForPhoto(args: INewComment): Promise<void> {
        console.assert(args.photo_id, 'photo_id is undefined');
        console.assert(args.collection_id, 'collection_id is undefined');
        let data: INewComment | FormData = args;

        if (args.audio_file) {
            data = this.formatFormData(args);
        } else {
            console.assert(args.text, 'new comment must have either text or an audio_file');
        }

        return this.postRequest(data);
    }

    private formatFormData(newRecord: INewComment): FormData {
        console.assert(newRecord, 'Paramater is undefined');

        const out = new FormData();
        const unixTime = Math.floor(Date.now() / 1000);
        const filename = `a${newRecord.collection_id}_p${newRecord.photo_id}_t${unixTime}.mp3`;

        out.append('photo_id', newRecord.photo_id.toString());
        out.append('collection_id', newRecord.collection_id.toString());
        if (newRecord.audio_file && newRecord.audio_length_ms) {
            out.append('audio_file', newRecord.audio_file!, filename);
            out.append('audio_length_ms', newRecord.audio_length_ms!.toString());
        } else if (newRecord.text) {
            out.append('text', newRecord.text);
        } else {
            throw new Error('Comment requires either text or audio');
        }

        if (newRecord.parent_id) {
            out.append('parent_id', newRecord.parent_id);
        }

        return out;
    }
}



// WEBPACK FOOTER //
// ./src/Services/CommentService.ts